export default __webpack_public_path__ + "static/media/1.0db79c02.jpg";